module.exports = __webpack_public_path__ + "img/btn_google_signin_dark_disabled_web@2x.38d2a0ce.png";